import { connect } from 'react-redux'
import BoardInfo from './BoardInfo'
import localize from '../../higherOrderComponents/localize'

const mapStateToProps = (state, ownProps) => {
  return {
    boardDef: state.boardDefs[state.boardDef]
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}


export default connect(mapStateToProps, mapDispatchToProps)(localize(BoardInfo))




// WEBPACK FOOTER //
// ./src/components/BoardInfo/index.js